const shl32 = (a, b) => a >> b;
export default shl32;
